<p-dialog
  [(visible)]="isVisible"
  [style]="{ width: '80vw' }"
  [draggable]="false"
  [resizable]="false"
  [showHeader]="false"
  [header]="'general.dashboard-map' | translate"
  modal="true"
  (onShow)="dialog.maximize()"
  (onHide)="close()"
  *ngIf="isVisible"
  #dialog
>

  <div class="row-container">

    <div class="map-filters">

      <div class="search-section">

        <div class="map-search">
          <i class="fa fa-search search-icon" [class.search-icon-open]="isSearchVissible" (click)="searchClicked()" role="button"  tabindex="-1">
            <span *ngIf="searchControl.value" class="red-dot"></span>
          </i>
          <div class="search-input-container" [hidden]="!isSearchVissible">
            <input type="text" class="form-control" [formControl]="searchControl"
                   [placeholder]="'general.dashboard-map.search-description' | translate" style="width: 100%;"/>
            <div *ngIf="isSearching" class="search-spinner">
              <i class="fa fa-spinner fa-spin"></i>
            </div>

            <app-map-search-navigation (markerChanged)="onMarkerChanged($event)"
                                       #searchNavigation></app-map-search-navigation>

          </div>
        </div>

      </div>

      <div class="time-displayer" *ngIf="!isFiltersVisible">
        <i class="fa fa-refresh" [class.fa-spin]="refreshing"></i> {{ activeFilters?.selectedRefreshRate }}
      </div>

      <div class="filters-title" (click)="filtersClicked()" role="button"  tabindex="-1" [class.filters-open]="isFiltersVisible">

        <svg _ngcontent-ng-c2062030372="" width="20" height="20" viewBox="0 0 24 24" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path _ngcontent-ng-c2062030372="" fill-rule="evenodd" clip-rule="evenodd"
                d="M20.8066 7.62355L20.1842 6.54346C19.6576 5.62954 18.4907 5.31426 17.5755 5.83866V5.83866C17.1399 6.09528 16.6201 6.16809 16.1307 6.04103C15.6413 5.91396 15.2226 5.59746 14.9668 5.16131C14.8023 4.88409 14.7139 4.56833 14.7105 4.24598V4.24598C14.7254 3.72916 14.5304 3.22834 14.17 2.85761C13.8096 2.48688 13.3145 2.2778 12.7975 2.27802H11.5435C11.0369 2.27801 10.5513 2.47985 10.194 2.83888C9.83666 3.19791 9.63714 3.68453 9.63958 4.19106V4.19106C9.62457 5.23686 8.77245 6.07675 7.72654 6.07664C7.40418 6.07329 7.08843 5.98488 6.8112 5.82035V5.82035C5.89603 5.29595 4.72908 5.61123 4.20251 6.52516L3.53432 7.62355C3.00838 8.53633 3.31937 9.70255 4.22997 10.2322V10.2322C4.82187 10.574 5.1865 11.2055 5.1865 11.889C5.1865 12.5725 4.82187 13.204 4.22997 13.5457V13.5457C3.32053 14.0719 3.0092 15.2353 3.53432 16.1453V16.1453L4.16589 17.2345C4.41262 17.6797 4.82657 18.0082 5.31616 18.1474C5.80575 18.2865 6.33061 18.2248 6.77459 17.976V17.976C7.21105 17.7213 7.73116 17.6515 8.21931 17.7821C8.70746 17.9128 9.12321 18.233 9.37413 18.6716C9.53867 18.9488 9.62708 19.2646 9.63043 19.5869V19.5869C9.63043 20.6435 10.4869 21.5 11.5435 21.5H12.7975C13.8505 21.5 14.7055 20.6491 14.7105 19.5961V19.5961C14.7081 19.088 14.9088 18.6 15.2681 18.2407C15.6274 17.8814 16.1154 17.6806 16.6236 17.6831C16.9451 17.6917 17.2596 17.7797 17.5389 17.9393V17.9393C18.4517 18.4653 19.6179 18.1543 20.1476 17.2437V17.2437L20.8066 16.1453C21.0617 15.7074 21.1317 15.1859 21.0012 14.6963C20.8706 14.2067 20.5502 13.7893 20.111 13.5366V13.5366C19.6717 13.2839 19.3514 12.8665 19.2208 12.3769C19.0902 11.8872 19.1602 11.3658 19.4153 10.9279C19.5812 10.6383 19.8213 10.3981 20.111 10.2322V10.2322C21.0161 9.70283 21.3264 8.54343 20.8066 7.63271V7.63271V7.62355Z"
                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
          <circle _ngcontent-ng-c2062030372="" cx="12.175" cy="11.889" r="2.63616" stroke="black" stroke-width="1.5"
                  stroke-linecap="round" stroke-linejoin="round"></circle>
        </svg>
        <span>{{ 'general.dashboard-map.filters.title' | translate }}</span>

      </div>

      <div class="filters-menu" [hidden]="!isFiltersVisible">

        <div class="filter-section">
          <div class="filter-title">
            {{ 'general.dashboard-map.filters.vehicles' | translate }}
          </div>
          <p-multiSelect id="vehicleTypes" [placeholder]="'general.dashboard-map.filters.vehicleTypes' | translate"
                         [options]="options.vehicleTypeOptions"
                         [(ngModel)]="options.filters.vehicle.vehicleTypes"></p-multiSelect>
          <p-dropdown [options]="options.engineOptions" [(ngModel)]="options.filters.vehicle.engine" optionValue="value"
                      [placeholder]="'general.select-please' | translate" appendTo="body"></p-dropdown>

          <div class="filter-line">
            <div class="form-check form-switch filter-check">
              <input class="form-check-input" type="checkbox" id="showVehicleDetails"
                     [(ngModel)]="options.filters.vehicle.showVehicleDetails">
              <label
                for="showVehicleDetails">{{ 'general.dashboard-map.filters.showVehicleDetails' | translate }}</label>
            </div>
          </div>
        </div>

        <div class="filter-section">
          <div class="filter-title">
            <p-toggleButton
              [(ngModel)]="options.filters.case.isActive"
              [onLabel]="'🟢 '+('general.dashboard-map.filters.case-show' | translate)"
              [offLabel]="'general.dashboard-map.filters.case-hide' | translate"/>
          </div>
          <p-multiSelect *ngIf="options.filters.case.isActive"
                         [placeholder]="'general.dashboard-map.filters.caseTypes' | translate"
                         [options]="options.caseTypeOptions"
                         [(ngModel)]="options.filters.case.caseTypes"></p-multiSelect>
          <p-multiSelect *ngIf="options.filters.case.isActive"
                         [placeholder]="'general.dashboard-map.filters.caseStatus' | translate"
                         [options]="options.caseStatusOptions"
                         [(ngModel)]="options.filters.case.statuses"></p-multiSelect>

          <div class="filter-line" *ngIf="options.filters.case.isActive">
            <div class="form-check form-switch filter-check">
              <input class="form-check-input" type="checkbox" id="withTeam" [(ngModel)]="options.filters.case.withTeam"
                     (ngModelChange)="checkChanged('withTeam')">
              <label for="withTeam">{{ 'general.dashboard-map.filters.withTeam' | translate }}</label>
            </div>
            <div class="form-check form-switch filter-check">
              <input class="form-check-input" type="checkbox" id="withoutTeam"
                     [(ngModel)]="options.filters.case.withoutTeam" (ngModelChange)="checkChanged('withoutTeam')">
              <label for="withoutTeam">{{ 'general.dashboard-map.filters.withoutTeam' | translate }}</label>
            </div>
          </div>

        </div>

        <div class="filter-section">
          <div class="filter-title">
            <p-toggleButton
              [(ngModel)]="options.filters.res.isActive"
              [onLabel]="'🟢 '+('general.dashboard-map.filters.res-show' | translate)"
              [offLabel]="'general.dashboard-map.filters.res-hide' | translate"/>
          </div>
          <p-dropdown *ngIf="options.filters.res.isActive" [options]="options.betweenTimeOptions"
                      [(ngModel)]="options.filters.res.time"
                      [placeholder]="'general.select-please' | translate"
                      appendTo="body" [filter]="true"></p-dropdown>
          <p-multiSelect *ngIf="options.filters.res.isActive"
                         [placeholder]="'general.dashboard-map.filters.caseTypes' | translate"
                         [options]="options.caseTypeOptions"
                         [(ngModel)]="options.filters.res.caseTypes"></p-multiSelect>
        </div>

        <div class="filter-section">
          <div class="filter-title">
            <p-toggleButton
              [(ngModel)]="options.filters.org.isActive"
              [onLabel]="'🟢 '+('general.dashboard-map.filters.org-show' | translate)"
              [offLabel]="'general.dashboard-map.filters.org-hide' | translate"/>
          </div>
          <p-dropdown *ngIf="options.filters.org.isActive" [options]="options.betweenTimeOptions"
                      [(ngModel)]="options.filters.org.time"
                      [placeholder]="'general.select-please' | translate"
                      appendTo="body" [filter]="true"></p-dropdown>
        </div>

        <div class="filter-section">
          <label for="vehicleTypes">
            <i class="fa fa-refresh"></i>&nbsp;
            {{ 'general.dashboard-map.filters.refreshTime' | translate }}
          </label>
          <p-dropdown [options]="options.pageRefreshOptions" [(ngModel)]="options.filters.selectedRefreshRate"
                      appendTo="body" [filter]="true"></p-dropdown>
          <span *ngIf="lastUpdate"
                class="filter-info-text">{{ ('general.dashboard-map.lastUpdateText' | translate) + ': ' + (lastUpdate | date:'HH:mm:ss') }}</span>
        </div>

        <div class="filter-section">
          <button class="btn btn-success" (click)="saveFilters()">
            {{ 'general.dashboard-map.filters.saveFilters' | translate }}
            <i class="fa fa-save ms-2"></i>
          </button>
        </div>

      </div>

    </div>

    <div class="map-container" *ngIf="isVisible">
      <div id="map"></div>
    </div>

    <div class="close-icon" (click)="close()" role="button"  tabindex="-1">X</div>

    <div class="info-container">
      <app-map-location-info (personelInfoClicked)="personelInfoClicked($event)"
                             (panelUpdated)="updateLocationRelation($event)" (panelClosed)="onInfoPanelClosed()"
                             #infoPanel></app-map-location-info>
    </div>

  </div>

  <app-watch-team-members-card #teamMembers></app-watch-team-members-card>

</p-dialog>
